/* jquery easing */
jQuery.easing["jswing"]=jQuery.easing["swing"];jQuery.extend(jQuery.easing,{def:"easeOutQuad",swing:function(x,t,b,c,d){return jQuery.easing[jQuery.easing.def](x,t,b,c,d)},easeInQuad:function(x,t,b,c,d){return c*(t/=d)*t+b},easeOutQuad:function(x,t,b,c,d){return-c*(t/=d)*(t-2)+b},easeInOutQuad:function(x,t,b,c,d){if((t/=d/2)<1)return c/2*t*t+b;return-c/2*(--t*(t-2)-1)+b},easeInCubic:function(x,t,b,c,d){return c*(t/=d)*t*t+b},easeOutCubic:function(x,t,b,c,d){return c*((t=t/d-1)*t*t+1)+b},easeInOutCubic:function(x,t,b,c,d){if((t/=d/2)<1)return c/2*t*t*t+b;return c/2*((t-=2)*t*t+2)+b},easeInQuart:function(x,t,b,c,d){return c*(t/=d)*t*t*t+b},easeOutQuart:function(x,t,b,c,d){return-c*((t=t/d-1)*t*t*t-1)+b},easeInOutQuart:function(x,t,b,c,d){if((t/=d/2)<1)return c/2*t*t*t*t+b;return-c/2*((t-=2)*t*t*t-2)+b},easeInQuint:function(x,t,b,c,d){return c*(t/=d)*t*t*t*t+b},easeOutQuint:function(x,t,b,c,d){return c*((t=t/d-1)*t*t*t*t+1)+b},easeInOutQuint:function(x,t,b,c,d){if((t/=d/2)<1)return c/2*t*t*t*t*t+b;return c/2*((t-=2)*t*t*t*t+2)+b},easeInSine:function(x,t,b,c,d){return-c*Math.cos(t/d*(Math.PI/2))+c+b},easeOutSine:function(x,t,b,c,d){return c*Math.sin(t/d*(Math.PI/2))+b},easeInOutSine:function(x,t,b,c,d){return-c/2*(Math.cos(Math.PI*t/d)-1)+b},easeInExpo:function(x,t,b,c,d){return t==0?b:c*Math.pow(2,10*(t/d-1))+b},easeOutExpo:function(x,t,b,c,d){return t==d?b+c:c*(-Math.pow(2,-10*t/d)+1)+b},easeInOutExpo:function(x,t,b,c,d){if(t==0)return b;if(t==d)return b+c;if((t/=d/2)<1)return c/2*Math.pow(2,10*(t-1))+b;return c/2*(-Math.pow(2,-10*--t)+2)+b},easeInCirc:function(x,t,b,c,d){return-c*(Math.sqrt(1-(t/=d)*t)-1)+b},easeOutCirc:function(x,t,b,c,d){return c*Math.sqrt(1-(t=t/d-1)*t)+b},easeInOutCirc:function(x,t,b,c,d){if((t/=d/2)<1)return-c/2*(Math.sqrt(1-t*t)-1)+b;return c/2*(Math.sqrt(1-(t-=2)*t)+1)+b},easeInElastic:function(x,t,b,c,d){var s=1.70158;var p=0;var a=c;if(t==0)return b;if((t/=d)==1)return b+c;if(!p)p=d*.3;if(a<Math.abs(c)){a=c;var s=p/4}else var s=p/(2*Math.PI)*Math.asin(c/a);return-(a*Math.pow(2,10*(t-=1))*Math.sin((t*d-s)*2*Math.PI/p))+b},easeOutElastic:function(x,t,b,c,d){var s=1.70158;var p=0;var a=c;if(t==0)return b;if((t/=d)==1)return b+c;if(!p)p=d*.3;if(a<Math.abs(c)){a=c;var s=p/4}else var s=p/(2*Math.PI)*Math.asin(c/a);return a*Math.pow(2,-10*t)*Math.sin((t*d-s)*2*Math.PI/p)+c+b},easeInOutElastic:function(x,t,b,c,d){var s=1.70158;var p=0;var a=c;if(t==0)return b;if((t/=d/2)==2)return b+c;if(!p)p=d*.3*1.5;if(a<Math.abs(c)){a=c;var s=p/4}else var s=p/(2*Math.PI)*Math.asin(c/a);if(t<1)return-.5*a*Math.pow(2,10*(t-=1))*Math.sin((t*d-s)*2*Math.PI/p)+b;return a*Math.pow(2,-10*(t-=1))*Math.sin((t*d-s)*2*Math.PI/p)*.5+c+b},easeInBack:function(x,t,b,c,d,s){if(s==undefined)s=1.70158;return c*(t/=d)*t*((s+1)*t-s)+b},easeOutBack:function(x,t,b,c,d,s){if(s==undefined)s=1.70158;return c*((t=t/d-1)*t*((s+1)*t+s)+1)+b},easeInOutBack:function(x,t,b,c,d,s){if(s==undefined)s=1.70158;if((t/=d/2)<1)return c/2*t*t*(((s*=1.525)+1)*t-s)+b;return c/2*((t-=2)*t*(((s*=1.525)+1)*t+s)+2)+b},easeInBounce:function(x,t,b,c,d){return c-jQuery.easing.easeOutBounce(x,d-t,0,c,d)+b},easeOutBounce:function(x,t,b,c,d){if((t/=d)<1/2.75){return c*7.5625*t*t+b}else if(t<2/2.75){return c*(7.5625*(t-=1.5/2.75)*t+.75)+b}else if(t<2.5/2.75){return c*(7.5625*(t-=2.25/2.75)*t+.9375)+b}else{return c*(7.5625*(t-=2.625/2.75)*t+.984375)+b}},easeInOutBounce:function(x,t,b,c,d){if(t<d/2)return jQuery.easing.easeInBounce(x,t*2,0,c,d)*.5+b;return jQuery.easing.easeOutBounce(x,t*2-d,0,c,d)*.5+c*.5+b}});


function setEqHeight() {
	equalheight('#we-believe .col');
	equalheight('#areas-main .item ul');
	equalminheight('#prepared-resources .item .inner');
	/*equalheight('#firm-home .content > div');
	equalheight('#ourfirm .col');*/
}



$(function() {
	$('a[href*=#]:not([href=#]).scroller').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-30
				}, 1000);
				return false;
			}
		}
	});
});

$(document).ready(function() {
	var map_home;

	function mapInitialize(map_) {
		var coords_ = $('#'+ map_).data('coords');

		if (coords_){
			var tmpCoords = coords_.split(',');
			var latitude = tmpCoords[0];
			var longtitude = tmpCoords[1];

			var latlng = new google.maps.LatLng(latitude,longtitude);

			var myOptions = {
				zoom: 16,
				center: latlng,
				disableDefaultUI: true,
				mapTypeId: google.maps.MapTypeId.ROADMAP
			};

			var map = new google.maps.Map(document.getElementById(map_), myOptions);

			var marker = new google.maps.Marker({
				position: latlng,
				map: map
			});
		}
	}


	function mapInitializeHome(map_) {
		var coords_ = $('#'+ map_).data('coords');

		if (coords_){
			var latitude = coords_[0][0];
			var longtitude = coords_[0][1];
			var latlng = new google.maps.LatLng(latitude,longtitude);

			var myOptions = {
				zoom: 16,
				center: latlng,
				disableDefaultUI: true,
				mapTypeId: google.maps.MapTypeId.ROADMAP
			};

			map_home = new google.maps.Map(document.getElementById(map_), myOptions);

			$.each(coords_, function(index, value){
				var latitude = value[0];
				var longtitude = value[1];
				var latlng = new google.maps.LatLng(latitude,longtitude);

				var marker = new google.maps.Marker({
					position: latlng,
					icon: 'public/images/ico-pointer.png',
					map: map_home
				});
			});
		}
	}



	$('.map-home').each(function(){
		var map_ = $(this).attr('id');
		mapInitializeHome(map_);
	});

	$('.map, .map-hold').each(function(){
	 var map_ = $(this).attr('id');
	 mapInitialize(map_);
	 });

	$(".accordion-contacts dt a").click(function(e){
		var coords_ = $(this).data("coords");

		if (coords_){
			var tmpCoords = coords_.split(',');
			var latitude = tmpCoords[0];
			var longtitude = tmpCoords[1];
			var latlng = new google.maps.LatLng(latitude,longtitude);
			map_home.setCenter(latlng);
		}
	});

	//////////////////
	$('header, .with-bg').each(function(e) {
		var bg_ = 'url(' + $(this).find('> img').attr('src') + ')';
		$(this).find('> img').hide();
		$(this).css('background-image', bg_);
	});
	$('.no-backgroundsize header, .no-backgroundsize .with-bg').each(function(e) {
		var bg_ = $(this).find('>img').attr('src');
		$(this).find('>img').hide();
		$(this).css({
			"filter" : "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='"+bg_+"', sizingMethod='scale')",
			"-ms-filter" : "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='"+bg_+"', sizingMethod='scale')"
		});
	});
	//////////////////

	var TIMEOUT = 300;
	$('body').wrapInner('<div class="page-inner-area"/>');
	$('body > .page-inner-area').wrapInner('<div id="wrapper"/>');
	$('<span class="fader"/>').appendTo('.page-inner-area').css('opacity', 0);
	$('.but-mobile').click(function(){
		if (!$('body').hasClass('open-menu')) {
			$('body').addClass('open-menu');
			$('.fader').css('display', 'block').animate({
				opacity: 1,
				right: '80%'
			}, TIMEOUT);
			$('#wrapper').animate({right: '80%'}, TIMEOUT);
			$('.menu-main').animate({'margin-right': 0}, TIMEOUT);
			$('.single-post').css('display', 'none');
		} else {
			$('body').removeClass('open-menu');
			$('.fader').animate({
				opacity: 0,
				right: 0
			}, TIMEOUT, function(){
				$(this).css('display', 'none');
			});
			$('#wrapper').animate({right: 0}, TIMEOUT);
			$('.menu-main').animate({'margin-right': '-80%'}, TIMEOUT);
			$('.single-post').css('display', 'block');
		};
		return false;
	});
	$('.fader').click(function(){
		$('body').removeClass('open-menu');
		$('.fader').animate({
			opacity: 0,
			right: 0
		}, TIMEOUT, function(){
			$(this).css('display', 'none')
		});
		$('#wrapper').animate({right: 0}, TIMEOUT);
		$('.menu-main').animate({'margin-right': '-80%'}, TIMEOUT);
		$('.single-post').css('display', 'block');
	});
	$('.menu-main > ul li').has('> ul').addClass('has-drop');
	$('.menu-main .has-drop > a').each(function(){
		$('<span class="opener visible-xs visible-sm"/>').appendTo(this);
	});
	$('.menu-main .has-drop > a .opener').click(function (){
		$(this).closest('li').find('> ul').slideToggle();
		$(this).closest('li').toggleClass('open');
		return false;
	});

	$(".side-address a.but-hours").on("click", function (e) {
		e.preventDefault();
		var parent = $(this).parents(".side-address");
		var container = parent.find(".popup-hours");
		var delta = parent.find(".address-header").innerHeight();
		var height = container.innerHeight();
		var position = $(this).position();
		var top = position.top+delta;
		container.css("top", top-height-15);
		container.toggleClass("visible");
		var offsetButton = $(this).offset().left;
		var offsetContainer = container.offset().left;
		container.find(".popup-arrow").css("left", (offsetButton - offsetContainer + $(this).innerWidth()/2)-10);
	});

	var slider_awards = $("#slider-awards");

	slider_awards.owlCarousel({
		items : 5,
		itemsDesktop : [1200,4],
		itemsDesktopSmall : [992,3],
		itemsMobile : [767,1],
		pagination: false,
		navigation: true
	});

	var slider_verdicts = $("#slider-verdicts");

	if(slider_awards.length){
		slider_verdicts.owlCarousel({
			singleItem:true,
			pagination: false,
			navigation: true,
		});
	}

	$("#areas .areas-block .opener").click(function () {
		e.preventDefault();
		var container = $(this).parent().find("ul");
		container.toggleClass("opened");
	});

	$(".btn-go-url").click(function (e) {
		e.preventDefault();
		var parent = $(this).parent(),
			href = parent.find("select option:selected").val();
		window.location = href;
	});

	$("[placeholder]").textPlaceholder();

	$('.accordion > dt > a').click(function (e) {
		e.preventDefault();
		var parent = $(this).parents("dt");
		if (!parent.hasClass("accordion-opened")) {
			$(".accordion > dt.accordion-opened").removeClass("accordion-opened");
			parent.addClass("accordion-opened");
			var targetId = $(this).attr("href");
			var target = $(targetId);
			var current = $(".accordion > dd.accordion-opened");
			target.addClass("accordion-opened");
			current.removeClass("accordion-opened");
			current.slideUp(400);
			target.slideDown(400);
		}
	});
});

$(window).load(function() {
	setEqHeight();
});

$(window).resize(function(){
	setEqHeight();
});

